<template>
  <v-app>
    <v-container>
      <v-card color="card1">
        <v-card-title>YouTube Statistics
        <v-spacer></v-spacer>
        <add-channel-dialog></add-channel-dialog>
        </v-card-title>
      </v-card>
      <v-card>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              class="ml-2 mr-16"
              v-model="search"
              prepend-icon="mdi-magnify"
              label="Search"
              single-line
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-data-table
          :items="items"
          :headers="headers"
          :search="search"
        >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>
                  Channel Statistics
                </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn class="ma-2 primary" @click="saveChannelData"><v-icon left>mdi-content-save</v-icon>Save Current Data</v-btn>
                  <v-btn disabled>Quota per day: 10000</v-btn>
             </v-toolbar>
            </template>
            <template v-slot:item.thumbnail="{item}">
              <v-avatar class="my-2">
                <v-img :src="item.thumbnail" height="60px" width="60px"></v-img>
              </v-avatar>
            </template>
            <template v-slot:item.growth="{item}">
              {{ item.growth }}
            </template>
            <template v-slot:item.info="{item}">
              <v-btn
                icon
                :to='"/youtubestatistics/" + item.userId'>
                <v-icon>mdi-information</v-icon>
              </v-btn>
              <delete-channel-dialog :item="item"></delete-channel-dialog>
            </template>
            <template v-slot:footer>
              <v-card-subtitle>**Due to YouTube policy change, subscriber count is altered to 3 significant figures</v-card-subtitle>
            </template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
export default {
  title: 'YouTube Statistics',
  data () {
    return {
      headers: [
        { text: 'Thumbnail', value: 'thumbnail' },
        { text: 'Channel Name', value: 'channelName' },
        { text: 'Country', value: 'country' },
        { text: 'Channel ID', value: 'userId' },
        { text: 'Subscription Count', value: 'subCount' },
        { text: 'Total Views', value: 'viewCount' },
        { text: 'Video Count', value: 'videoCount' },
        { text: 'Average Views', value: 'averageViews' },
        { text: 'Created Date', value: 'createdDate' },
        { text: 'Info', value: 'info' }
      ],
      search: ''
    }
  },
  methods: {
    saveChannelData () {
      this.$store.dispatch('saveChannelData')
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    items () {
      return this.$store.getters.loadedChannelIds
    }
  }
}
</script>
